import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SIGNUP_TYPE } from '../../data/define';
import { useUserStore } from '../../store/useUserStore';
import { ON_KIDS_VISITED } from '../../data/define';
import Url from '../../data/url';
import ImgElephant from '../../assets/image/img_elephant.png';
import FullHeightContainer from '../../component/common/FullHeightContainer';
import Splash from '../../component/login/Splash';
import FirstAccessRegisterKids from '../../component/login/FirstAccessKidRegister';
import { useTranslation } from '../../hook/useTranslation';

export default function LoginPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const user = useUserStore();
  const setUser = user.setUser;
  const alreadyVisited = localStorage.getItem(ON_KIDS_VISITED) === 'true';

  // splash conversion
  useEffect(() => {
    const timer = setTimeout(() => {
      setUser((prev) => ({
        ...prev,
        isSplashShown: true,
      }));
    }, 3000);
    return () => clearTimeout(timer);
  }, [setUser]);

  const handleGoToLoginPage = (openType: string) => {
    navigate(`${Url.LoginPass}?type=${openType}`);
  };

  return (
    <FullHeightContainer>
      {!user.isSplashShown && <Splash />}
      {user.isSplashShown && !alreadyVisited && <FirstAccessRegisterKids />}
      {user.isSplashShown && alreadyVisited && (
        <div className="pageInner bg-[#F4FFFF]">
          <div className="w-full h-full flex flex-col items-center justify-center">
            <div className="w-full flex flex-col items-center justify-center gap-2 ">
              <div className="text-[28px] font-[700] text-center">
                {t('login.title_line1')}
                <br />
                {t('login.title_line2')}
              </div>
              <div className="text-[#363636] text-[14px] font-[400] text-center">
                {t('login.subtitle')}
              </div>
            </div>
            <div className="relative w-full flex flex-col items-center justify-center gap-2">
              <img
                src={ImgElephant}
                alt="elepants"
                className="max-w-[398px] max-h-[396px]"
                style={{
                  objectFit: 'contain',
                }}
              />
            </div>
          </div>
          <div className="z-1000 absolute bottom-0 left-0 gap-2 bg-transparent right-0 flex flex-col p-5 justify-center w-full font-bold leading-6">
            <button
              type="button"
              className="text-[#371D1E] p-2 rounded-[8px]"
              style={{ background: '#FAE100' }}
              onClick={() => handleGoToLoginPage(SIGNUP_TYPE.KAKAO)}
            >
              {t('login.kakao')}
            </button>
            <button
              type="button"
              className="text-[#fff] p-2 rounded-[8px]"
              style={{ background: '#FF3A4A', color: '#fff' }}
              onClick={() => handleGoToLoginPage(SIGNUP_TYPE.PASS)}
            >
              {t('login.pass')}
            </button>
          </div>
        </div>
      )}
    </FullHeightContainer>
  );
}
